module.exports = __webpack_public_path__ + "img/Laurine.1d274a71.png";